import { twMergeConfig } from '../utils';

import { tv } from 'tailwind-variants';

type SpinnerSize = 'sm' | 'md' | 'lg';
export interface SpinnerProps {
  size: SpinnerSize;
  className?: string;
}

const spinnerTV = tv(
  {
    base: 'animate-spin rounded-full border-2 border-sem-l-text-high  border-b-prim-sumi-20',
    variants: {
      size: {
        sm: 'size-4',
        md: 'size-8',
        lg: 'size-12',
      },
    },
  },
  {
    twMergeConfig,
  }
);

export const Spinner: React.FC<SpinnerProps> = ({ size = 'sm', className }) => {
  const style = spinnerTV({ size, className });
  return <div className={style} />;
};
